import { useState, useEffect } from 'react';
import enhancedApiClient from '../api/enhancedApiClient';

export const useUserProfile = (userId) => {
  const [userProfile, setUserProfile] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchUserProfile = async () => {
      if (!userId) {
        setLoading(false);
        return;
      }

      try {
        setLoading(true);
        const profile = await enhancedApiClient.getUser(userId);
        
        if (profile) {
          // Handle mixed DynamoDB/regular format
          const getValue = (field) => {
            if (typeof field === 'string') return field;
            if (field?.S) return field.S;
            if (field?.N) return parseInt(field.N);
            return field;
          };
          
          const userData = {
            id: getValue(profile.id),
            email: getValue(profile.email),
            phone: getValue(profile.phone),
            name: getValue(profile.name),
            userType: getValue(profile.userType),
            currentEventId: getValue(profile.currentEventId),
            currentVendorId: getValue(profile.currentVendorId),
            createdAt: getValue(profile.createdAt)
          };
          setUserProfile(userData);
        } else {
          setError('User profile not found');
        }
      } catch (err) {
        console.error('Failed to fetch user profile:', err);
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchUserProfile();
  }, [userId]);

  return { userProfile, loading, error };
};